import { defineComponent as _defineComponent } from 'vue'
import BCXCheckbox from '@/components/molecules/forms/BCXCheckbox.vue';
import LinkIcon from '@/components/svg/link.svg?inline';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import { computed } from 'vue';
import useInviteTools from '@/views/invites/utils/useInviteTools';
import EditIcon from '@/components/molecules/EditIcon.vue';
import BCXTable from '@/components/BCXTable.vue';
import useI18n from '@/mixins/useI18n';
import { InviteCode, MIN_DISPLAYED_CODES } from '@/models/Invitation';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvitesCodesTable',
  setup(__props) {

const { getFormattedDate } = useFormattedDateTime();
const {
  el, copyCode, currentCode, invites, revealLink, revealedLink
} = useInviteTools();
const { t } = useI18n();
const { isMobileWidth } = useResponsiveness();

const fields = ['code', 'used', 'notes', 'date'];

const headerTitles = computed(() => [
  t('invites.columns.code'),
  t('invites.columns.used'),
  t('invites.columns.notes'),
  t('invites.columns.date')
]);

const getDisplayValue = (fieldName: string, obj: InviteCode) => {
  switch (fieldName) {
    case 'code': return obj.inviteCode;
    case 'used': return obj.userMarkedAsUsed;
    case 'notes': return obj.userNote;
    case 'date': return obj.userMarkedAsUsed ? getFormattedDate(obj.userMarkedAsUsedTs || new Date()) : '';
  }
  return '-';
};


return { __sfc: true,getFormattedDate, el, copyCode, currentCode, invites, revealLink, revealedLink, t, isMobileWidth, fields, headerTitles, getDisplayValue, BCXCheckbox, LinkIcon, EditIcon, BCXTable, MIN_DISPLAYED_CODES }
}

})